module.exports = __webpack_public_path__ + "img/ydjk.43865b71.png";